import {baseFetch} from "./axios-instance";

const sugestedProductsService = async () => await baseFetch.get(`config/other/search-not-found-page-data`);

export default sugestedProductsService;